import type { JSX } from 'react';

import { cn } from '@/lib/utils';

import { CASE_STATUS_LABELS, type AgentCaseStatus } from '../../model/case';

interface CaseStatusBadgeProps {
  status: AgentCaseStatus;
}

const STATUS_CLASSES: Record<AgentCaseStatus, string> = {
  pending: 'bg-warning/15 text-warning',
  attended: 'bg-success-light text-success',
  rejected: 'bg-error-light text-error',
};

const CaseStatusBadge = ({ status }: CaseStatusBadgeProps): JSX.Element => (
  <span className={cn('inline-block rounded-full px-2 py-0.5 text-[0.7rem] font-semibold', STATUS_CLASSES[status])}>
    {CASE_STATUS_LABELS[status]}
  </span>
);

export default CaseStatusBadge;
